import $ from 'jquery';
/* ===============================================================
Header
=============================================================== */
class Header {
    constructor() {
        this.headerMain = $('.irantheme-header-main');

        if (!this.headerMain.length) return;

        this.initElements();
        this.initVariables();
        this.events();
    }

    initElements() {
        // Header alignment
        this.headerAlignment = this.headerMain.find(
            '.irantheme-header-alignment',
        );

        // Profile elements
        this.togglerShortProfile = $('#irantheme-short-profile-toggler');
        this.dropdownShortProfile = $(
            '.irantheme-navbar-options-user-alignment-dropdown',
        );

        // Navigation elements
        this.navbarLisTopBar = $(
            '.irantheme-header-topbar .irantheme-container-navbar-menu .irantheme-navbar-menu-ul > li',
        );
        this.navbarLis = $(
            '.irantheme-header-main .irantheme-container-navbar-menu .irantheme-navbar-menu-ul > li',
        );

        // Other elements
        this.miniProfile = this.headerMain.find('.irantheme-mini-profile');
        this.triggerMenu = this.headerMain.find(
            '.irantheme-navbar-trigger-holder',
        );

        // Cache selectors that are used multiple times
        this.$window = $(window);
        this.$adminBar = $('#wpadminbar');
        this.$topBar = $('.irantheme-header-topbar');
        this.$megaMenu = this.headerMain.find('.irantheme-mega-menu-item');
    }

    initVariables() {
        this.headerHeight = this.headerAlignment
            .find('.irantheme-header-wrapper-main')
            .height();
        this.headerOffsetTop = this.$adminBar.length
            ? this.$adminBar.height()
            : 0;

        // Cache data attributes
        this.dataClassDefault = this.headerMain.data('class-color-default');
        this.dataClassScrolled = this.headerMain.data('class-scroll');
        this.dataClassTransparency = this.headerMain.data('class-transparent');

        // Throttle variables
        this.resizeTimer = null;
        this.scrollTimer = null;
    }

    events() {
        // Use requestAnimationFrame for smoother performance
        this.$window.on('load', () => this.onWindowLoad());
        this.$window.on('resize', () => this.handleResize());
        this.$window.on('scroll', () => this.handleScroll());

        // Single event handler for short profile
        this.togglerShortProfile.on('click', (e) => {
            e.preventDefault();
            this.showHideShortProfileUser();
        });
    }

    onWindowLoad() {
        requestAnimationFrame(() => {
            this.initMegaMenu();
            this.checkElementsTopbar();
            this.addImageToSubMenu();
            this.handleHeaderEffects();
        });
    }

    initMegaMenu() {
        if (!this.$megaMenu.length) return;

        const $menuItems = this.$megaMenu.find('.sub-menu > .menu-item');
        $menuItems.first().addClass('active');

        // Use event delegation for better performance
        this.$megaMenu
            .off('mouseover mouseleave')
            .on('mouseover', '.sub-menu > .menu-item', function () {
                $menuItems.removeClass('active');
                $(this).addClass('active');
            })
            .on('mouseleave', '.sub-menu', function () {
                $menuItems.removeClass('active');
                $menuItems.first().addClass('active');
            });
    }

    handleResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            this.headerOffsetTop = this.$adminBar.length
                ? this.$adminBar.height()
                : 0;
            this.headerStickyAction();
            this.checkElementsTopbar();
        }, 100);
    }

    handleScroll() {
        // Throttle scroll events
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
            this.headerOffsetTop = this.$adminBar.length
                ? this.$adminBar.height()
                : 0;
            this.handleHeaderEffects();
        }, 16); // ~60fps
    }

    handleHeaderEffects() {
        requestAnimationFrame(() => {
            this.headerChangeBgColorScrolled();
            this.headerStickyAction();
            this.headerShrinkAction();
        });
    }

    showHideShortProfileUser() {
        this.dropdownShortProfile.stop(true, true).fadeToggle(100);
        this.togglerShortProfile.toggleClass('active');
    }

    headerChangeBgColorScrolled() {
        const scrollTop = this.$window.scrollTop();
        const isScrolled = scrollTop > 5;
        const logo = $(
            '.irantheme-logo-brand .irantheme-logo-img-holder:not(.irantheme-logo-mobile)',
        );
        const logoMobile = $(
            '.irantheme-logo-brand .irantheme-logo-img-holder.irantheme-logo-mobile',
        );

        if (isScrolled) {
            this.handleScrolledState(logo, logoMobile);
        } else {
            this.handleDefaultState(logo, logoMobile);
        }
    }

    handleScrolledState(logo, logoMobile) {
        if (
            this.dataClassScrolled &&
            this.dataClassScrolled.indexOf(this.dataClassDefault) === -1
        ) {
            this.headerMain
                .removeClass(this.dataClassDefault)
                .addClass(this.dataClassScrolled);

            if (
                this.dataClassTransparency &&
                this.headerMain.hasClass('irantheme-header-sticky')
            ) {
                this.headerMain.removeClass(this.dataClassTransparency);
            }
        } else if (
            this.dataClassTransparency &&
            this.headerMain.hasClass('irantheme-header-sticky')
        ) {
            this.headerMain.removeClass(this.dataClassTransparency);
        }

        this.updateLogoAndProfile(logo, logoMobile);
    }

    handleDefaultState(logo, logoMobile) {
        if (
            this.dataClassScrolled &&
            this.dataClassScrolled.indexOf(this.dataClassDefault) === -1
        ) {
            this.headerMain
                .removeClass(this.dataClassScrolled)
                .addClass(this.dataClassDefault);

            if (this.dataClassTransparency) {
                this.headerMain.addClass(this.dataClassTransparency);
            }
        } else if (this.dataClassTransparency) {
            this.headerMain.addClass(this.dataClassTransparency);
        }

        this.updateLogoAndProfile(logo, logoMobile);
    }

    updateLogoAndProfile(logo, logoMobile) {
        const isDark = this.headerMain.hasClass('irantheme-header-dark');
        const isWhite = this.headerMain.hasClass('irantheme-header-white');

        if (isWhite) {
            this.swapLogo(logo, logoMobile, 'img-dark');
            this.miniProfile
                .removeClass('irantheme-mini-profile-dark')
                .addClass('irantheme-mini-profile-white');
        } else if (isDark) {
            this.swapLogo(logo, logoMobile, 'img-white');
            this.miniProfile
                .removeClass('irantheme-mini-profile-white')
                .addClass('irantheme-mini-profile-dark');
        }
    }

    swapLogo(logo, logoMobile, dataAttr) {
        const logoImg = logo.data(dataAttr);
        const mobileImg = logoMobile.data(dataAttr);

        if (logoImg) {
            logo.find('.irantheme-logo-img').attr('src', logoImg);
        }
        if (mobileImg) {
            logoMobile.find('.irantheme-logo-img').attr('src', mobileImg);
        }
    }

    headerStickyAction() {
        const scrollTop = this.$window.scrollTop();
        const isSticky = this.headerMain.hasClass('irantheme-header-sticky');
        const isFixed = this.headerMain.hasClass('irantheme-header-fixed');

        if (isSticky) {
            this.handleStickyHeader(scrollTop);
        } else if (isFixed) {
            this.handleFixedHeader();
        }
    }

    handleStickyHeader(scrollTop) {
        const isMobile = this.$window.outerWidth() <= 600;
        const hasBorder = this.headerMain.hasClass(
            'irantheme-header-border-mode',
        );

        if (scrollTop > 5) {
            const topPosition = isMobile ? 0 : this.headerOffsetTop;
            this.headerMain.css({
                position: 'fixed',
                top: topPosition,
                borderWidth: 0,
            });
        } else {
            const topbarHeight = this.$topBar.height() || 0;
            const headerTop =
                topbarHeight > 0
                    ? this.headerOffsetTop + topbarHeight
                    : this.headerOffsetTop;

            const cssProps = {
                position: 'fixed',
                top: headerTop,
            };

            if (hasBorder) {
                cssProps.borderWidth = 1;
            }

            this.headerMain.css(cssProps);
        }
    }

    handleFixedHeader() {
        const topbarHeight = this.$topBar.height() || 0;
        this.headerMain.css('top', topbarHeight);
    }

    headerShrinkAction() {
        if (
            this.headerMain.hasClass('irantheme-header-sticky') &&
            this.headerAlignment.hasClass('irantheme-header-shrink')
        ) {
            const scrollTop = this.$window.scrollTop();
            const newHeight =
                scrollTop > 5 ? this.headerHeight * 0.8 : this.headerHeight;

            this.headerAlignment
                .find('.irantheme-header-wrapper-main')
                .height(newHeight);
        }
    }

    addImageToSubMenu() {
        this.headerMain
            .find(
                '.irantheme-container-navbar-menu .irantheme-navbar-menu-ul .irantheme-image-menu-item',
            )
            .each((index, element) => {
                const $element = $(element);
                const imageUrl = $element
                    .children('.menu-item-link')
                    .data('image');

                if (imageUrl) {
                    $element
                        .children('.sub-menu')
                        .css('backgroundImage', `url(${imageUrl})`);
                }
            });
    }

    checkElementsTopbar() {
        const isMobile = this.$window.outerWidth() < 1200;

        if (isMobile) {
            const topbarElements = this.$topBar
                .find('.irantheme-navbar-topbar-alignment')
                .children();
            let isAllHidden = true;

            topbarElements.each((index, element) => {
                if ($(element).is(':visible')) {
                    isAllHidden = false;
                    return false; // Break the loop
                }
            });

            this.$topBar.toggle(!isAllHidden);
        } else {
            this.$topBar.show();
        }
    }
}

export default Header;
